import { render, staticRenderFns } from "./L01DOM.vue?vue&type=template&id=4ccfb4ec&"
import script from "./L01DOM.vue?vue&type=script&lang=js&"
export * from "./L01DOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports